import { API } from '@/inc/api';
import { bus } from '@/main';

export const payments = {
    namespaced: true,
    state: {
        payments: [],
        hasMore: true,
        page: 0,
        perPage: 200,
    },
    mutations: {
        setPayments(state, payload) {
            state.payments = payload;
        },
        setHasMore(state, payload) {
            state.hasMore = payload;
        },
        setPage(state, payload) {
            state.page = payload;
        }
    },
    actions: {
        async loadPayments({ commit, state }) {
            if( !state.hasMore ) {
                return Promise.resolve();
            }

            try {
                let api = new API();
                let offset = state.page * state.perPage;
                offset = offset == 0 ? 0 : offset + 1;

                let res = await api.get(`/admin/payments/${offset}/${state.perPage}`);

                if( !res.data.status ) {
                    bus.$emit('alert', { 
                        text: res.data.message, 
                        color: res.data.error ? 'error' : 'warning'
                    });
                    return Promise.reject(false);
                }

                commit('setPayments', res.data.data);
                commit('setHasMore', res.data.data.length == state.perPage);
                commit('setPage', state.page + 1);
                return Promise.resolve();
            } 
            catch( error ) {
                return Promise.reject(error);
            }
        },
        async findPayments({ commit, state }, query ) {
            try {
                let api = new API();
                let res = await api.get(`/admin/payments/0/${state.perPage}${query ? '?q=' + query : ''}`);

                if( !res.data.status ) {
                    bus.$emit('alert', { 
                        text: res.data.message, 
                        color: res.data.error ? 'error' : 'warning'
                    });
                    return Promise.reject(false);
                }

                commit('setPayments', res.data.data);
                return Promise.resolve();
            } 
            catch( error ) {
                return Promise.reject(error);
            }
        },
        async updatePayment({ commit, state }, payload) {
            try {
                let api = new API();
                let res = await api.put('/admin/payment', {
                    id          : payload.id,
                    amount      : payload.paymentAmount,
                    confirmation: payload.confirmationNumber,
                    memo        : payload.memo
                });

                if( !res.data.status ) {
                    bus.$emit('alert', { 
                        text: res.data.message, 
                        color: res.data.error ? 'error' : 'warning'
                    });
                    return Promise.reject(false);
                }

                let newPayment = res.data.data;
                let payments = state.payments.map( payment => {
                    if( payment.id == newPayment.id ) {
                        payment.paymentAmount = newPayment.paymentAmount;
                        payment.confirmationNumber = newPayment.confirmationNumber;
                        payment.memo = newPayment.memo;
                    }
                    return payment;
                });

                commit('setPayments', payments);
                return Promise.resolve();
            }
            catch( error ) {
                return Promise.reject( error );
            }
        },
        async deletePayment({ commit, state }, paymentId) {
            try {
                let api = new API();
                let res = await api.post(`/admin/payments/delete/${paymentId}`, {});

                if( !res.data.status ) {
                    bus.$emit('alert', { 
                        text: res.data.message, 
                        color: res.data.error ? 'error' : 'warning'
                    });
                    return Promise.reject(false);
                }

                let payments = state.payments.filter( payment => payment.id != paymentId );
                commit('setPayments', payments);
                return Promise.resolve();
            }
            catch( error ) {
                return Promise.reject( error );
            }
        },
    },
    getters: {
        payments        : (state) => state.payments,
        hasMore         : (state) => state.hasMore,
        page            : (state) => state.page,
    }
};